// The only thing the connection module is allowed to know about how bytes actually move — mirrors
// src/server/transport/port.ts's shape deliberately, so the same kind of substitution (a real transport
// vs. an in-memory one for tests) works on this side too. A real browser WebSocket is the only production
// implementation; test/client/net/*.test.ts instead adapts the server's own MemoryTransport, so a
// connection test drives the real server code across an in-process "socket" with no port, no process.
export interface ClientSocket {
  send(data: string): void;
  close(): void;
  onMessage(cb: (data: string) => void): void;
  onOpen(cb: () => void): void;
  onClose(cb: () => void): void;
}

export function browserSocket(url: string): ClientSocket {
  const ws = new WebSocket(url);
  return {
    send: data => ws.send(data),
    close: () => ws.close(),
    onMessage(cb) { ws.addEventListener('message', e => { if (typeof e.data === 'string') cb(e.data); }); },
    onOpen(cb) { ws.addEventListener('open', () => cb()); },
    onClose(cb) { ws.addEventListener('close', () => cb()); },
  };
}
